<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'home'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">회원 정보</h2>
          </div>

          <div class="formArea">
            <span class="label">아이디</span>
            <div class="iptWrap">
              <input
                type="text"
                class="ipt uiAct"
                placeholder="wellmall@naver.com"
                title="아이디 입력(wellmall@naver.com)"
                :value="this.user.userId"
                readonly="readonly"
              />
              <button class="btnIco_del" tabindex="-1"><span class="blind">해당 필드 입력값 삭제</span></button>
            </div>

            <span class="label">이름</span>
            <div class="iptWrap">
              <input type="text" class="ipt uiAct" placeholder="웰릭스" title="아이디 입력(웰릭스)" :value="this.user.userName" readonly="readonly" />
              <button class="btnIco_del" tabindex="-1"><span class="blind">해당 필드 입력값 삭제</span></button>
            </div>

            <span class="label">성별</span>
            <ul class="iptGroup iptBtn">
              <li>
                <input
                  type="radio"
                  class="ipt notDel uiAct"
                  name="rdo"
                  id="rdo1_1"
                  checked="checked"
                  value="RCSB000M"
                  v-model="user.sex"
                  :disabled="user.originalSex != ''"
                />
                <label for="rdo1_1"><span class="ico">남성</span></label>
              </li>
              <li>
                <input
                  type="radio"
                  class="ipt notDel uiAct"
                  name="rdo"
                  id="rdo1_2"
                  value="RCSB00WM"
                  v-model="user.sex"
                  :disabled="user.originalSex != ''"
                />
                <label for="rdo1_2"><span class="ico">여성</span></label>
              </li>
            </ul>

            <span class="label">생년월일</span>
            <div class="iptWrap">
              <input
                type="text"
                class="ipt uiAct"
                placeholder="2020.00.00"
                title="생년월일 입력(2020.00.00)"
                :value="user.birth | dateFormatter('.')"
                readonly="readonly"
              />
              <button class="btnIco_del" tabindex="-1">
                <span class="blind">해당 필드 입력값 삭제</span>  
              </button>
            </div>

            <span class="label">휴대폰번호</span>
            <div class="setBtnS">
              <input
                type="tel"
                class="ipt"
                title="휴대폰번호 입력"
                placeholder="휴대폰번호"
                :value="user.mobile | phoneFormatter"
                readonly="readonly"
              />
              <button type="button" class="btn_g m" @click="authUserMobilePopOpen">수정</button>
            </div>

            <span class="label">비밀번호</span>
            <div class="setBtnS">
              <input type="password" class="ipt" title="비밀번호 입력" placeholder="비밀번호" value="12341234" readonly="readonly" />
              <button type="button" class="btn_g m" @click="changePwdPopOpen">수정</button>
            </div>

            <span class="label">설치/배송 주소</span>
            <div class="setAddr">
              <input
                type="tel"
                id="addr_1"
                class="ipt"
                title="설치 주소 입력 (우편번호)"
                placeholder="우편번호"
                readonly="readonly"
                v-model="user.addrPost"
              />
              <button type="button" class="btn_g m" @click="addrPopupOpen">우편번호찾기</button>
            </div>
            <input
              type="text"
              id="addr_2"
              class="ipt"
              placeholder="기본주소"
              title="설치 주소 입력 (기본주소)"
              readonly="readonly"
              v-model="user.addrRoad"
            />
            <input type="text" id="addr_3" class="ipt" placeholder="상세주소 입력" title="설치 주소 입력 (상세주소)" v-model="user.addrRemark" />

            <!-- 0728삭제 : 사용성없음 추후 필요시 SR요청
                  <span class="label">환불 계좌 정보</span>
            <select class="ipt" title="은행종류 선택">
              <option value="" disabled="disabled" selected="selected">은행을 선택해주세요.</option>
              <option value="">선택1</option>
              <option value="">선택2</option>
                  </select>
                  <input type="text" id="addr_3" class="ipt" placeholder="계좌번호 입력" title="계좌번호 입력">
            <div class="iptWrap">
                      <input type="text" id="ipt1_2" class="ipt uiAct" placeholder="웰릭스" title="고객명 노출(웰릭스)" value="웰릭스" readonly="readonly">
                      <button class="btnIco_del" tabindex="-1">
                          <span class="blind">해당 필드 입력값 삭제</span>
                      </button>
                  </div>
                  <p class="txtList_remark">환불계좌 등록은 본인 명의 계좌만 가능합니다.</p>
            -->

            <div class="mt25">
              <button type="button" class="links txtM arrow" @click="serviceUseAgree"><span>서비스이용동의</span></button>
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">선택 정보</h2>
          </div>

          <div class="formArea">
            <p class="label">
              관심 상품 선택
              <span>(중복 선택 가능)</span>
            </p>
            <ul class="iptGroup div_2 giftChoice mt10">
              <template v-for="(value, key) in likePrdList">
                <li>
                  <input type="checkbox" class="ipt" :value="value.bsnId + value.bsnVal" name="chk1" :id="'chk1_' + key" v-model="user.myPrdList" />
                  <label :for="'chk1_' + key">
                    <span class="img"><img :src="value.imgUrl" /></span>
                    <span>{{ value.bsnName }}</span>
                  </label>
                </li>
              </template>
            </ul>
            <p class="label">가족 구성</p>
            <ul class="iptGroup iptBtn div_2 mt10">
              <template v-for="(value, key) in familyList">
                <li v-if="key < 4">
                  <input type="radio" class="ipt" name="rdo2" :id="'btn2_' + key" :value="value.bsnId + value.bsnVal" v-model="user.family" />
                  <label :for="'btn2_' + key">
                    <span class="ico">{{ value.bsnName }}</span>
                  </label>
                </li>

                <li v-else-if="key == 4" class="brbl brbr">
                  <input type="checkbox" class="ipt" name="chkpet1" id="chkpet1" :value="value.bsnId + value.bsnVal" v-model="user.familyAdd" />
                  <label for="chkpet1">
                    <span class="ico">{{ value.bsnName }}</span>
                  </label>
                </li>
              </template>
            </ul>
          </div>

          <div class="ar mt25">
            <button type="button" class="links" @click="withdrawal"><span>회원탈퇴</span></button>
          </div>

          <!-- btnArea (s) -->
          <div class="btnArea sticky">
            <a href="javascript:;" class="btn_p" @click="setUserInfo">회원정보수정</a>
          </div>
          <!-- btnArea (e) -->
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <FindAddr v-if="findAddr" @callback="selectAddr" @close="close"></FindAddr>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <loginChangePwdPop v-if="changePwdPop" :userId="user.userId" @close="close" />
    <authUserMobilePop v-if="authUserMobilePop" @close="close" @callAuthNum="callAuthNum" />
    <ConfirmPop @confirm="confirm" v-if="confirmPop" @cancel="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import FindAddr from '@/components/comm/FindAddr';
import ConfirmPop from '@/components/popup/ConfirmPop';
import MessagePop from '@/components/popup/MessagePop';
import loginChangePwdPop from '@/views/app/mypage/info/LoginChangePwdPop';
import authUserMobilePop from '@/views/app/mypage/info/AuthUserMobilePop';
import $ from 'jquery';
export default {
  name: 'changeUserInfo',
  components: {
    MessagePop,
    FindAddr,
    ConfirmPop,
    loginChangePwdPop,
    authUserMobilePop,
  },
  mounted() {
    console.log(JwtService.getUserInfo());
    this.userInfoInit();
    this.optionInit();
  },
  data() {
    return {
      headerTitle: '회원정보수정',
      chgUserInfo: false,
      showDiv: 'main',
      password: null,
      newPassword: null,
      passwordChk: null,
      likePrdList: [],
      familyList: [],
      msg: '',
      messagePop: false,
      confirmPop: false,
      changePwdPop: false,
      authUserMobilePop: false,
      findAddr: false,
      user: {
        agreeUsingService: false,
        agreeDate: '',
        family: null,
        familyAdd: null,
        myPrdList: [],
        sex: '',
        userId: '',
        birth: '',
        userName: '',
        addrPost: '',
        addrRoad: '',
        addrRemark: '',
        addrBdNum: '',
        addrJibun: '',
        telecomCompCode: '',
        mobile: '',
        originalSex: '',
      },
    };
  },
  methods: {
    userInfoInit() {
      let today = new Date();
      let thisYear = today.getFullYear();

      // console.log(thisYear.toString().substring(2));
      ApiService.service('GET', 'user/auth/checked')
        .then(({ data }) => {
          // console.log(data);
          if (data.errorCode != '') {
            // this.msg = data.error;
            // this.messagePop = true;
            this.$router.push({ name: 'authAccount' });
          } else {
            let yy = '20';
            if (data.result.user.birth.substring(0, 2) > thisYear.toString().substring(2)) {
              yy = '19';
            }

            this.user.userId = data.result.user.userId;
            this.user.sex = data.result.user.sexCode;
            this.user.birth = yy + data.result.user.birth;
            this.user.userName = data.result.user.userName;
            this.user.addrPost = data.result.user.addrPost;
            this.user.addrRoad = data.result.user.addrRoad;
            this.user.addrJibun = data.result.user.addrJibun;
            this.user.addrRemark = data.result.user.addrRemark;
            this.user.addrBdNum = data.result.user.addrBdNum;
            this.user.mobile = data.result.user.mobile;
            this.user.telecomCompCode = data.result.user.telecomCompCode;
            this.user.myPrdList = data.result.prodGroupCodes;
            this.user.agreeUsingService = data.result.agreeUsingService;
            this.user.agreeDate = data.result.agreeDate;
            this.user.originalSex = data.result.user.sexCode;
            for (let value of data.result.familyTypes) {
              if (value == 'CUS30005') {
                //반려동물 체크박스
                this.user.familyAdd = value;
              } else {
                this.user.family = value;
              }
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    optionInit() {
      ApiService.service('GET', '/common/commonItem/CUS1,CUS3')
        .then(({ data }) => {
          // console.log(data.result);
          for (let key in data.result) {
            // console.log(key);
            if (data.result[key].bsnId == 'CUS1') {
              this.likePrdList = data.result[key].commonItems;
            } else if (data.result[key].bsnId == 'CUS3') {
              this.familyList = data.result[key].commonItems;
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
          this.categoryList = [];
        });
    },
    addrPopupOpen() {
      this.findAddr = true;
    },
    selectAddr(data) {
      this.user.addrPost = data.zip;
      this.user.addrRoad = data.nadr1;
      this.user.addrCode = data.nnmb;
      this.user.addrJibun = data.adr1;
      this.close();
    },
    changePwdPopOpen() {
      this.changePwdPop = true;
      $('body').addClass('popOn');
    },
    authUserMobilePopOpen() {
      this.authUserMobilePop = true;
    },
    close() {
      // console.log(this.user);
      this.messagePop = false;
      this.confirmPop = false;
      this.bottomPop = false;
      this.authUserMobilePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
      this.changePwdPop = false;
      $('body').removeClass('popOn');
      if (this.chgUserInfo) {
        this.$router.push({ name: 'myPage' });
      }
    },
    callAuthNum(data) {
      // console.log(data);
      if (!(data.err != '' && data.err != undefined)) {
        this.user.mobile = data.mobile;
        this.user.telecomCompCode = data.telecomCompCode;
      }
      this.close();
      this.userInfoInit();
    },
    //탈퇴
    withdrawal() {
      this.msg = '지금까지 받은 혜택이 아깝지 않으세요?<br>더 많은 헤택 받을 수 있는데 정말?<br>탈퇴하실건가요?';
      this.confirmPop = true;
    },
    confirm() {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출
      this.$router.push({ name: 'withdrawal' });
    },
    serviceUseAgree() {
      this.$router.push({ name: 'serviceUseAgree', params: { agreeUsingService: this.user.agreeUsingService, agreeDate: this.user.agreeDate } });
    },
    checkData() {
      console.log(this.user);
    },
    //회원정보수정
    setUserInfo() {
      //familyType 데이터 만들기
      let familyType = [];
      familyType.push(this.user.family);
      if (this.user.familyAdd) {
        familyType.push('CUS30005');
      }

      ApiService.service('PUT', 'user/auth', {
        familyTypes: familyType,
        prodGroupCodes: this.user.myPrdList,
        user: {
          addrBdNum: this.user.addrCode,
          addrJibun: this.user.addrJibun,
          addrPost: this.user.addrPost,
          addrRemark: this.user.addrRemark,
          addrRoad: this.user.addrRoad,
          birth: this.user.birth,
          mobile: this.user.mobile,
          sexCode: this.user.sex,
          telecomCompCode: this.user.telecomCompCode,
        },
      })
        .then(({ data }) => {
          // console.log(data);
          if (data.isSucceed) {
            let userInfo = JwtService.getUserInfo();
            userInfo.addrJibun = this.user.addrJibun;
            userInfo.addrBdNum = this.user.addrCode;
            userInfo.addrPost = this.user.addrPost;
            userInfo.addrRemark = this.user.addrRemark;
            userInfo.addrRoad = this.user.addrRoad;
            userInfo.birth = this.user.birth.substring(2);
            userInfo.mobile = this.user.mobile;
            userInfo.sex = this.user.sex;
            userInfo.telecomCompCode = this.user.telecomCompCode;
            JwtService.setUserInfo(userInfo);
            this.msg = '회원정보가 변경되었습니다.';
            this.messagePop = true;
            this.chgUserInfo = true;
          } else {
            this.msg = '회원정보 변경에 실패하였습니다.';
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
  },
};
</script>
